<template>
  <div class="employeeManage">
    <!-- 搜索 -->
    <!-- <div class="search_bar">
      <van-search
        v-model="listQuery.name"
        show-action
        placeholder="请输入员工姓名进行搜索"
        @search="onSearch"
      >
        <template slot="action">
          <div @click="onSearch">搜 索</div>
        </template>
      </van-search>
    </div>-->
    <div class="content" v-if="roleList">
      <van-index-bar :index-list="list_index" :sticky="false" highlight-color="#2c3e50">
        <van-index-anchor v-for="(item,index) in list" :key="index" :index="index">
          <span>{{index}}</span>
          <van-cell
            v-for="(citem,cindex) in item"
            :key="cindex"
            :disabled="citem.status == 2"
            :value="citem.status == 2?'已停用':citem.mobile"
            :label="roleList[citem.role_type] "
            @click="use_type == 1?backPage(citem):toEmployee(citem)"
          >
            <template #title>
              <div class="van-ellipsis" style="width:3.7rem">{{citem.realname}}</div>
            </template>
          </van-cell>
        </van-index-anchor>
      </van-index-bar>
    </div>
    <div class="add-btn" @click="$router.push('/mine/employee/addEmployee')">添加员工</div>
  </div>
</template>

<script>
import { employee_list, employee_role_list } from "@/api/work/mine/employee";
export default {
  name: "employeeManage",
  data() {
    return {
      list: {},
      list_index: [],

      listQuery: {
        name: ""
      },
      roleList: null,

      use_type: 1
    };
  },

  created() {
    // 判断是不是 调用的
    if (this.$route.query.use_type == 1) {
      this.use_type = 1;
    } else {
      this.use_type = 0;
    }
    this.getRoleType();
    this.getList();
    this.$navigation.on("back", (to, from) => {
      if (
        from.route.name == "mine_employee_addEmployee" ||
        from.route.name == "mine_employee_employeeDetail"
      ) {
        this.getList();
      }
    });
  },
  mounted() {},
  methods: {
    // 点击了搜索按钮
    onSearch() {
      this.getList();
    },

    // 获取列表
    getList() {
      employee_list(this.listQuery).then(res => {
        if (res.code == 200) {
          this.list = res.data.list;
          this.list_index = [];
          for (const key in res.data.list) {
            this.list_index.push(key);
          }
        }
      });
    },

    // 获取所有角色类型
    getRoleType() {
      employee_role_list().then(res => {
        if (res.code == 200) {
          let list = {};
          for (let i = 0; i < res.data.length; i++) {
            const item = res.data[i];
            list[item.id + ""] = item.name;
          }
          this.roleList = list;
        }
      });
    },
    // 去员工管理详情
    toEmployee(item) {
      this.$router.push({
        path: "/mine/employee/employeeDetail",
        query: {
          uid: item.uid,
          item: encodeURI(JSON.stringify(item))
        }
      });
    },

    // 返回上一页
    backPage(item) {
      this.$route.meta.backData = item;
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.employeeManage {
  height: calc(100vh - 0.88rem);
  overflow-y: auto;
  .search_bar {
    position: sticky;
    top: 0.88rem;
    z-index: 2;
    box-shadow: 0 0 0.05rem 0.05rem #f1f1f1;
  }
  .content {
    padding-bottom: 1.2rem;
  }
  .add-btn {
    width: 100%;
    line-height: 1rem;
    background-color: #31b158;
    color: #fff;
    font-size: 0.36rem;
    text-align: center;
    position: fixed;
    bottom: 0;
  }
}
</style>